(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  if (!customElements.get('mancini-header')) {
    customElements.define(
      'mancini-header',
      class ManciniHeader extends HTMLElement {
        connectedCallback() {
          this.dialog = this.querySelector('[data-mancini-menu-dialog]');
          this.openButton = this.querySelector('[data-mancini-menu-open]');
          this.closeButton = this.querySelector('[data-mancini-menu-close]');

          this.openButton?.addEventListener('click', this.openMenu);
          this.closeButton?.addEventListener('click', this.closeMenu);
          this.dialog?.addEventListener('close', this.handleClose);
        }

        disconnectedCallback() {
          this.openButton?.removeEventListener('click', this.openMenu);
          this.closeButton?.removeEventListener('click', this.closeMenu);
          this.dialog?.removeEventListener('close', this.handleClose);
        }

        openMenu = () => {
          if (!this.dialog || this.dialog.open) return;
          this.dialog.showModal();
          this.openButton?.setAttribute('aria-expanded', 'true');
          document.documentElement.style.overflow = 'hidden';
        };

        closeMenu = () => {
          this.dialog?.close();
        };

        handleClose = () => {
          this.openButton?.setAttribute('aria-expanded', 'false');
          document.documentElement.style.removeProperty('overflow');
          this.openButton?.focus();
        };
      },
    );
  }

  } catch(e) { console.error(e); }
})();
})();
